import { memo } from 'react'
import { baseInputClasses, labelClasses } from '../../styles/inputStyles'

/**
 * UserEditForm - Editable form fields for user details
 * Includes name, email, phone, and permission checkboxes
 */
const UserEditForm = memo(function UserEditForm({
  formData,
  onChange
}) {
  const handleChange = (field, value) => {
    onChange({ ...formData, [field]: value })
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={labelClasses}>First Name</label>
          <input
            type="text"
            value={formData.firstName}
            onChange={(e) => handleChange('firstName', e.target.value)}
            className={baseInputClasses}
          />
        </div>
        <div>
          <label className={labelClasses}>Last Name</label>
          <input
            type="text"
            value={formData.lastName}
            onChange={(e) => handleChange('lastName', e.target.value)}
            className={baseInputClasses}
          />
        </div>
      </div>

      <div>
        <label className={labelClasses}>Email</label>
        <input
          type="email"
          value={formData.email}
          onChange={(e) => handleChange('email', e.target.value)}
          className={baseInputClasses}
        />
      </div>

      <div>
        <label className={labelClasses}>Phone</label>
        <input
          type="tel"
          value={formData.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
          className={baseInputClasses}
        />
      </div>

      <div className="space-y-2 pt-4 border-t">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={formData.isActive}
            onChange={(e) => handleChange('isActive', e.target.checked)}
            className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
          />
          <span className="ml-2 text-sm text-gray-700">Active Account</span>
        </label>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={formData.isAdmin}
            onChange={(e) => handleChange('isAdmin', e.target.checked)}
            className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
          />
          <span className="ml-2 text-sm text-gray-700">Administrator Privileges</span>
        </label>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={formData.isVerified}
            onChange={(e) => handleChange('isVerified', e.target.checked)}
            className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
          />
          <span className="ml-2 text-sm text-gray-700">Email Verified</span>
        </label>
      </div>
    </div>
  )
})

export default UserEditForm
